import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const customerServices = createApi({
  reducerPath: "customerServices",
  tagTypes: ["customer", "Activity", "ChatRequests", "ChatRooms", "appoinment"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.upswap.app/api",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    gettimeslotsProvider: builder.query({
      providesTags: ["customer"],
      query: ({ id, date, serviceId, time }) => ({
        url: `appointments/get-time-slots/?provider_id=${id}&for_date=${date}&time=${time}&service_id=${serviceId}`,
        method: "GET",
      }),
    }),
    createChatRequest: builder.mutation({
      invalidatesTags: ["ChatRequests"],
      query: (newPost) => ({
        url: "/chat/create-chat-request/",
        method: "POST",
        body: newPost,
      }),
    }),
    createActivity: builder.mutation({
      query: (newPost) => ({
        url: "/activities/create/",
        method: "POST",
        body: newPost,
      }),
    }),
    getChatRequests: builder.query({
      query: (activityId) => `/chat/get-chat-requests/${activityId}/`,
      providesTags: ["ChatRequests"],
    }),
    acceptChatRequest: builder.mutation({
      query: (body) => ({
        url: "/chat/accept-chat-request/",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["ChatRequests"],
    }),
    rejectChatRequest: builder.mutation({
      query: ({ requestId, body }) => ({
        url: `activity/confirm-reject/participation/${requestId}/`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["ChatRequests"],
    }),
    participationRequest: builder.mutation({
      invalidatesTags: ["vendor", "ChatRooms", "Activity"],
      query: ({ activityId, body }) => ({
        url: `/activity/confirm-reject/participation/${activityId}/`,
        method: "POST",
        body: body,
      }),
    }),

    // Activity details
    getActivityDetails: builder.query({
      query: (activityId) => `activities/details/${activityId}/`,
      providesTags: ["Activity"],
    }),

    // Chat rooms
    getChatRooms: builder.query({
      query: (activityId) => `chat/get/chat-rooms/${activityId}/`,
      providesTags: ["ChatRooms"],
    }),

    getDealDetails: builder.query({
      query: (params) => {
        const { deal_uuid, ...locationDetails } = params;
        const locationQuery = new URLSearchParams({
          location: JSON.stringify(locationDetails),
        }).toString();
        return {
          url: `/deals/details/${deal_uuid}/?${locationQuery}`,
          method: "GET",
        };
      },
    }),
    // ...
    handleChatRequest: builder.mutation({
      query: ({ requestId, action }) => ({
        url: "chat/accept-chat-request/",
        method: "PATCH",
        body: [
          {
            id: requestId,
            is_accepted: action === "accept",
            is_rejected: action === "reject",
          },
        ],
      }),
      invalidatesTags: ["ChatRequests", "ChatRooms"],
    }),
    participationRemove: builder.mutation({
      invalidatesTags: ["vendor", "ChatRooms", "Activity"],
      query: ({ activityId, body }) => ({
        url: `/activity/remove/participant/${activityId}/`,
        method: "POST",
        body: body,
      }),
    }),
    sendVerificationOtp: builder.mutation({
      query: (payload) => ({
        url: "send-verification-otp/",
        method: "POST",
        body: payload,
      }),
    }),
    updateActivityStatus: builder.mutation({
      invalidatesTags: ["Activity"],
      query: (activityID) => ({
        url: `/activities/deactivate/${activityID}/`,
        method: "POST",
      }),
    }),
     getInActivityActivities: builder.query({
      providesTags: ["Activity"],
      query: (user_id) => ({
        url: `/activities/deactivated/${user_id}/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGettimeslotsProviderQuery,
  useCreateChatRequestMutation,
  useCreateActivityMutation,
  useGetChatRequestsQuery,
  useAcceptChatRequestMutation,
  useRejectChatRequestMutation,
  useParticipationRequestMutation,
  useGetActivityDetailsQuery,
  useGetChatRoomsQuery,
  useHandleChatRequestMutation,
  useGetDealDetailsQuery,
  useParticipationRemoveMutation,
  useSendVerificationOtpMutation,
  useUpdateActivityStatusMutation,
  useGetInActivityActivitiesQuery
} = customerServices;

export default customerServices;
